module.exports = __webpack_public_path__ + "img/luckbg.c29be18e.png";